import React, { useEffect, useState } from 'react';
import './MultiStepForm.css'
import OverviewStep from './steps/OverviewStep';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import Step6 from './steps/Step6';
import UserData from './steps/UserData';
import ResultStep from './steps/ResultStep';
import CalendlyStep from './steps/CalendlyStep';


const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});


useEffect(() => {
  console.log(formData);
}, [formData]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [completedSteps, setCompletedSteps] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false
  });

  const nextStep = () => {
    setCompletedSteps({
      ...completedSteps,
      [currentStep]: true
    });
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const submitFormData = async () => {
    try {
      setIsSubmitting(true);
      // Aquí puedes reemplazar la URL con tu endpoint real
      const response = await fetch('your-api-endpoint', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Error al enviar los datos');
      }

      const result = await response.json();
      // Puedes manejar la respuesta exitosa aquí
      console.log('Datos enviados exitosamente:', result);
      
      setCompletedSteps({
        ...completedSteps,
        [currentStep]: true,
        8: true
      });
      // Avanzar al paso final después de enviar los datos
      nextStep();
    } catch (error) {
      console.error('Error:', error);
      // Aquí puedes manejar los errores, por ejemplo mostrar un mensaje al usuario
    } finally {
      setIsSubmitting(false);
    }
  };



  const renderProgressBar = () => {
    const steps = [
      { number: 1, label: 'Inicio' },
      { number: 2, label: 'Color' },
      { number: 3, label: 'Corte' },
      { number: 4, label: 'Pureza' },
      { number: 5, label: 'Quilates' },
      { number: 6, label: 'Montura' },
      { number: 7, label: 'Material' },
      { number: 8, label: 'Datos de contact' },
      { number: 9, label: 'Resultado' }
    ];

    return (
      <div className="progress-bar">
        {steps.map((step, index) => (
          <div 
            key={step.number} 
            className={`progress-step ${currentStep === step.number ? 'active' : ''} ${completedSteps[step.number] ? 'completed' : ''}`}
          >
            <div className="step-number">{step.number}</div>
            <div className="step-label">{step.label}</div>
            {index < steps.length - 1 && <div className="step-connector" />}
          </div>
        ))}
      </div>
    );
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <OverviewStep
            nextStep={nextStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 2:
        return (
          <Step1
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 3:
        return (
          <Step2
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 4:
        return (
          <Step3
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 5:
        return (
          <Step4
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 6:
        return (
          <Step5
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 7:
        return (
          <Step6
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
            isSubmitting={isSubmitting}
          />
        );
        case 8:
        return (
          <UserData
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
            isSubmitting={isSubmitting}
          />
        );
      case 9:
        return (
          <ResultStep
            prevStep={prevStep}
            formData={formData}
            nextStep={nextStep}
          />
        );
        case 10:
        return (
          <CalendlyStep
          nextStep={nextStep}
            prevStep={prevStep}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="multi-step-form">
      {renderProgressBar()}
      {renderStep()}
    </div>
  );
};

export default MultiStepForm;



